import { Component, Inject, OnInit, signal } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { AdminService } from "app/services/admin/admin.service";
import { EvaluationService } from "app/services/evaluation/evaluation.service";

@Component({
    selector: "objetivos-history",
    templateUrl: "./objetivos-history.component.html",
    styleUrls: ["./objetivos-history.component.scss"],
    standalone: false
})
export class DialogObjetivosHistoricoComponent implements OnInit {
    personId;

    page = 0;
    pageSize = 5;

    readonly objetivos = signal<any[]>([]);
    readonly total = signal(0);
    readonly loading = signal(true);
    readonly periodos = signal<any[]>([]);

    user;
    person;
    permisosPDA;
    mainPeriod;

    nombre: "";
    perido_seleccionado: null;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private translate: TranslateService,
        private evSvc: EvaluationService,
        private adminSvc: AdminService,
        private dialogRef: MatDialogRef<DialogObjetivosHistoricoComponent> // Inyecta MatDialogRef
    ) {
        this.personId = this.data.personId;
        this.user = this.data.user;
        this.person = this.data.person;
        this.permisosPDA = this.data.permisosPDA;
        this.mainPeriod = this.data.mainPeriod;
    }

    ngOnInit(): void {
        this.getPeriods();
        this.getPA();
    }

    getPA() {
        this.loading.set(true);
        // Si es para objetivos de departamento, usar el endpoint específico
        if (this.data.isDepartamento && this.data.organigramaId) {
            this.evSvc
                .getHistoricoObjetivosDepartamento(this.data.organigramaId, this.page, this.pageSize, {
                    periodo: this.perido_seleccionado
                })
                .subscribe({
                    next: (data) => {
                        this.objetivos.set(data.elements ?? []);
                        this.total.set(data.total ?? 0);
                        this.loading.set(false);
                    },
                    error: () => this.loading.set(false)
                });
        } else {
            // Para objetivos de usuario individual, usar el endpoint original
            this.evSvc
                .getHistoricoObjetivos(this.personId, this.pageSize, this.page, { periodo: this.perido_seleccionado })
                .subscribe({
                    next: (data) => {
                        this.objetivos.set(data.elements ?? []);
                        this.total.set(data.total ?? 0);
                        this.loading.set(false);
                    },
                    error: () => this.loading.set(false)
                });
        }
    }

    getPeriods() {
        this.adminSvc.getAllPeriodosRevision(true).subscribe(
            (data) => {
                this.periodos.set(data.periodos ?? []);
            },
            (err) => {
                console.log(err);
            }
        );
    }

    filtrar() {
        this.page = 0;
        this.objetivos.set([]);
        this.total.set(0);

        this.getPA();
    }

    pageChanged(event) {
        this.page = event.pageIndex;
        this.getPA();
    }

    onChangeElementValue(evt) {
        const _body = {
            id: evt.id,
            result: evt.value
        };
        this.evSvc.saveActionPlanResult(_body).subscribe((data) => {
            console.log(data);
        });
        console.log(evt);
    }

    closeThis() {
        this.dialogRef.close();
    }
}
